import { createSlice } from '@reduxjs/toolkit';
import { getAccessToken } from '../../services/authStorage';

const initialState = {
  isAuthenticated: Boolean(getAccessToken()),
  user: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth: (state, action) => {
      const authPayload = action.payload ?? null;
      const resolvedUser = authPayload?.user ?? authPayload;

      state.isAuthenticated = true;
      state.user = resolvedUser ?? null;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
    },
  },
});

export const { setAuth, logout } = authSlice.actions;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectUser = (state) => state.auth.user;

export default authSlice.reducer;
